import { useDispatch, useSelector, useStore } from 'react-redux';

import type { Store, RootState, AppDispatch } from '.';

// Use throughout the app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<Store>();
